import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Typography, message, Tabs, Form, DatePicker, Button, Space, Select } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { restApi } from '../../../constants/api';
import PersistentDrawerLeft from '../../../components/reusable/admin/Main';

const { Title, Text } = Typography;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f5f5f5;
`;

const StyledCard = styled(Card)`
  max-width: 800px;
  width: 100%;
  border-radius: 16px;
`;

const StyledButton = styled(Button)`
  background-color: #1677ff;
  border-radius: 8px;
  font-weight: 500;

  &:hover {
    background-color: #0056d2;
  }
`;

const AttendanceCyclePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [cycle, setCycle] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    restApi(`/api/users/cycles/${id}`, 'GET')
      .then((res: any) => {
        if (Array.isArray(res?.data)) {
          setCycle(res.data[0]);
        }
      })
      .catch((err) => {
        console.error(err);
        message.error('Failed to fetch cycle data');
      });
  }, [id]);

  const handleBack = () => navigate(-1);

  const handleManualSubmit = async (values: any) => {
    if (!cycle) return;
    const payload = {
      user_id: cycle.user_id,
      attendance_date: dayjs(values.attendance_date).format('YYYY-MM-DD'),
      status: values.status || 'PRESENT',
      cycle_id: id

    };

    try {
      setLoading(true);
      await restApi('/api/attendance', 'POST', payload);
      message.success('Attendance marked successfully');
      form.resetFields();
      navigate(`/admin/users/cycles/${id}/attendance/view`);
    } catch (err: any) {
      const e = err?.response?.data?.message || 'Failed to mark attendance';
      message.error(e);
    } finally {
      setLoading(false);
    }
  };

  const ManualTab = (
    <Form form={form} layout="vertical" onFinish={handleManualSubmit}
      initialValues={{ status: 'PRESENT' }}>
      <Form.Item label="Attendance Date" name="attendance_date" rules={[{ required: true, message: 'Please select date' }]}>
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item label="Status" name="status" rules={[{ required: true, message: 'Please select a status' }]}>
        <Select placeholder="Select status">
          <Select.Option value="PRESENT">PRESENT</Select.Option>
          <Select.Option value="ABSENT">ABSENT</Select.Option>
          <Select.Option value="LEAVE">LEAVE</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <StyledButton type="primary" htmlType="submit" loading={loading} disabled={loading} block>
          {/* Submit Attendance */}
          {loading ? "Upload..." : "Submit Attendance"}
        </StyledButton>
      </Form.Item>
    </Form>
  );


  return (
    <PersistentDrawerLeft>
      <StyledContainer>
        <StyledCard>
          <Space style={{ justifyContent: 'space-between', width: '100%' }}>
            <Title level={4}>Attendance Cycle Details</Title>
            <Button onClick={handleBack}>Back</Button>
          </Space>

          {cycle ? (
            <div style={{ marginBottom: 24 }}>
              <Text><strong>User Name:</strong> {cycle.user_name}</Text><br />
              <Text><strong>Department:</strong> {cycle.department_name}</Text><br />
              <Text><strong>Designation:</strong> {cycle.user_type_name}</Text><br />
              <Text><strong>Days to Cover:</strong> {cycle.total_number_of_days_need_to_cover}</Text><br />
              <Text><strong>Reminders:</strong> {cycle.no_of_days_reminders} Days</Text><br />
              <Text><strong>Covered:</strong> {cycle.total_number_of_days_covered}</Text><br />
              <Text><strong>Start:</strong> {dayjs(cycle.start_date).format('DD-MM-YYYY')}</Text><br />
              <Text><strong>End:</strong> {dayjs(cycle.end_date).format('DD-MM-YYYY')}</Text>
            </div>
          ) : (
            <Text>Loading cycle details...</Text>
          )}

          <Tabs defaultActiveKey="manual" items={[
            {
              key: 'manual',
              label: 'Manual',
              children: ManualTab,
            },
            {
              key: 'import',
              label: 'Import',
              children: <Text>Coming soon...</Text>,
            },
          ]} />
        </StyledCard>
      </StyledContainer>
    </PersistentDrawerLeft>
  );
};

export default AttendanceCyclePage;
